export default "__VITE_ASSET__WZddMi7D__"